export const DashboardDTO = (raw = {}) => {

    const apps = raw.applications || {};
    const enroll = raw.enrollments || {};

    return {
        applications: {
            NEW: apps.NEW ?? 0,
            REVIEWING: apps.REVIEWING ?? 0,
            APPROVED: apps.APPROVED ?? 0,
            REJECTED: apps.REJECTED ?? 0,
            WITHDRAWN: apps.WITHDRAWN ?? 0,
            total: apps.total ?? 0
        },

        enrollments: {
            ACTIVE: enroll.ACTIVE ?? 0,
            COMPLETED: enroll.COMPLETED ?? 0,
            DROPPED: enroll.DROPPED ?? 0,
            SUSPENDED: enroll.SUSPENDED ?? 0,
            total: enroll.total ?? 0
        },

        activeTerm: raw.activeTerm
            ? {
                publicId: raw.activeTerm.publicId,
                name: raw.activeTerm.name,
                startDate: raw.activeTerm.startDate,
                endDate: raw.activeTerm.endDate,
                enrollmentLimit: raw.activeTerm.enrollmentLimit,
                enrollmentCount: raw.activeTerm.enrollmentCount ?? 0,
                remainingSlots: raw.activeTerm.remainingSlots
            }
            : null,

        recentApplications: (raw.recentApplications || []).map(a => ({
            publicId: a.publicId,
            fullName: a.fullName,
            interestArea: a.interestArea,
            status: a.status,
            createdAt: a.createdAt
        })),

        recentEnrollments: (raw.recentEnrollments || []).map(e => ({
            publicId: e.publicId,
            fullName: e.fullName,
            status: e.status,
            source: e.source,
            enrolledAt: e.enrolledAt
        })),

        today: {
            applications: raw.today?.applications ?? 0,
            approved: raw.today?.approved ?? 0,
            enrollments: raw.today?.enrollments ?? 0
        },

        thisWeek: {
            applications: raw.thisWeek?.applications ?? 0,
            approved: raw.thisWeek?.approved ?? 0,
            enrollments: raw.thisWeek?.enrollments ?? 0
        },

        enrollmentsByTerm: raw.enrollmentsByTerm || [],
        applicationTrend: raw.applicationTrend || []
    };
};
